module.exports = __webpack_public_path__ + "img/pannel_icon_active.f2353598.svg";